@if (isVisible) {
    <div class="winning-result-card">
        <div class="winning-content-wrapper">
            <div [ngClass]="numberDetails.backgroundClass" class="number-box">
                {{ displayNumber }}
            </div>
            @if (winningNumber !== 0 && winningNumber !== 37) {
                <div class="details-block">
                    <div class="detail-line">
                        <span class="detail-value color-{{ numberDetails.color }}">
                            {{ numberDetails.color | uppercase }}
                        </span>
                    </div>
                    <div class="detail-line">
                        <span class="detail-value">{{ numberDetails.evenOrOdd | uppercase }}</span>
                    </div>
                    <div class="detail-line">
                        <span class="detail-value">{{ numberDetails.half }}</span>
                    </div>
                    <div class="detail-line">
                        <span class="detail-value">{{ numberDetails.third }}</span>
                    </div>
                </div>
            }
        </div>
    </div>
}
